import { render, staticRenderFns } from "./UiTypography.vue?vue&type=template&id=60954a6d"
import script from "./UiTypography.vue?vue&type=script&lang=js"
export * from "./UiTypography.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports